import { Component, OnInit,TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Empty_PM_Service_Interface, PM_Service_Interface } from 'src/app/Interface/PM_Service_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_ServiceService } from 'src/app/Service/PM/PM_Service.service';

@Component({
  selector: 'app-PMServiceList',
  templateUrl: './PMServiceList.component.html',
  styleUrls: ['./PMServiceList.component.scss']
})
export class PMServiceListComponent implements OnInit {

  Token: string = ""
  Filter_Title: string = ""
  Filter_Description:string=''
  Filter_Manufacturer:string=''
  Filter_Model:string=''
  Filter_Code:string=''

  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private PM_Service_Service: PM_ServiceService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    public router: Router,
    private modalService: BsModalService
  ) { }


  DataList_PM: Array<PM_Service_Interface> = []
  unServiceDeviceBehfa: Array<DeviceBehfa_Interface> = []
  unstarted: Array<DeviceBehfa_Interface> = []
  unDelay: Array<DeviceBehfa_Interface> = []
  Data_Seleted_Delete: PM_Service_Interface = Empty_PM_Service_Interface()



  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token, 1162).subscribe(
      data => {
        this.ReadData_PM()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_PM() {
    this.Procssing = true
    this.PM_Service_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_PM = data['result']
        this.unServiceDeviceBehfa = data['unServiceDeviceBehfa']
        this.unstarted = data['unstarted']
        this.unDelay = data['unDelay']
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }



  Change_Filter() {
    this.page = 0
  }

  Delete(item: PM_Service_Interface) {

    this.modalRef_Delete.hide()
    this.PM_Service_Service.DeletePM(item.id, this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("Service deleted successfully.")
        this.ReadData_PM()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }




  //#region PM Form

  Selected_PM_Record: PM_Service_Interface
  Selected_PM_Record_Switcher: string = 'List'
  Set_List_PM_View() {
    this.Selected_PM_Record_Switcher= 'List'
  }

  Set_Form_PM_View(item:PM_Service_Interface,Switcher:string) {
    this.Selected_PM_Record = item
    this.Selected_PM_Record_Switcher= Switcher
  }

  Set_Form_PM_View_Add() {
    this.Selected_PM_Record = Empty_PM_Service_Interface()
    this.Selected_PM_Record_Switcher= 'Form'
  }

  //#endregion

}
